<div class="background-blue">
  <div class="claims-page-banner container">
    {{ accountClaimsHeadingText }}
  </div>
</div>
<assurant-loader *ngIf="!isLoaded" [showProgress]="true"></assurant-loader>

<ng-container *ngIf="isLoaded && isActive">
  <ng-container *ngIf="!isSecondaryDesign">
    <div class="container claims-page">
      <ng-container *ngIf="!claimEligible">
        <div class="container">
          <div class="container header-container">
            <div class="header-title-container">{{ heading }}</div>
          </div>
          <div class="header-desc-container">
            <span [innerHTML]="description"></span>
          </div>
        </div>

        <!-- Image -->
        <div class="container img-container secondary-account">
          <div class="claims-text-container">
            <p class="desc u-body-1 pb-2" [innerHTML]="startClaimText"></p>
            <h4 class="heading pb-3">{{ displayClaimDate }}</h4>
            <div class="image-container">
              <img class="device-img mb-3" src="./assets/images/devices.svg" alt="home_devices" />
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="claimEligible">
        <div class="container header-container">
          <div class="header-title-container">{{ claimsHeadingText }}</div>
          <div class="header-claims-status-link-container">
            <div class="icon-container">
              <mat-icon [svgIcon]="'action-view-list-blue'"></mat-icon>
            </div>
            <div class="status-link-container" *ngIf="viewClaimsHistoryLink">
              <button class="link p-0" (click)="claimHistoryAndStatus()">{{ viewClaimsHistoryLink?.label }}</button>
            </div>
            <div class="status-link-container" *ngIf="!viewClaimsHistoryLink">
              <button class="link" (click)="claimHistoryAndStatus()">Claims History & Status</button>
            </div>
          </div>
        </div>
        <div class="sub-header-container">
          <div class="sub-header-directions">
            {{ claimsSubheadingText }}
          </div>
        </div>
        <div class="questions-container">
          <pgh-claims-question
            [title]="fileAClaimPage?.question1Title"
            [options]="fileAClaimPage?.question1Options"
            [divider]="activeStep !== 1 || negativePath"
            (chooseAnswer)="changeStep($event, 1)"
          ></pgh-claims-question>

          <pgh-claims-question
            *ngIf="activeStep !== 1"
            [title]="fileAClaimPage?.question2Title"
            [options]="fileAClaimPage?.question2Options"
            [moreInfo]="fileAClaimPage?.question2MoreInfo"
            [divider]="activeStep !== 2 || negativePath"
            (chooseAnswer)="changeStep($event, 2)"
          ></pgh-claims-question>

          <pgh-claims-question
            *ngIf="(activeStep == 3 && !negativePath) || (activeStep == 1 && isMobilePlanActive && negativePath)"
            [title]="fileAClaimPage?.question3Title" [finalText]="fileAClaimPage?.finalText"
            [buttonText]="fileAClaimPage?.buttonText" [deviceInfo]="true" [categoriesDropdown]="categoriesDropdown"
            [sspCategories]="sspCategories" [subCategoriesDropdown]="subCategoriesDropdown"
            [brandsSearchBox]="brandsSearchBox" [modelTextBox]="modelTextBox"
            [categoriesDropdownOptions]="categoriesDropdownOptions" [deviceNameTextBox]="deviceNameTextBox"
            [serialNumberTextBox]="serialNumberTextBox" [purchasePriceTextBox]="purchasePriceTextBox"
            [purchaseDateTextBox]="purchaseDateTextBox" [divider]="false"
            [childCertNumber$]="childCertNumber$"></pgh-claims-question>

          <pgh-claims-message
            *ngIf="
              activeStep == 1 &&
              negativePath &&
              !isMobilePlanActive &&
              fileAClaimPage?.question1Message &&
              fileAClaimPage?.question1Message.length
            "
            [claimMessageInfo]="fileAClaimPage?.question1Message[0]"
            [showChatCTA]="false"
          ></pgh-claims-message>

          <pgh-claims-message
            *ngIf="
              activeStep == 2 &&
              negativePath &&
              fileAClaimPage?.question2Message &&
              fileAClaimPage?.question2Message.length
            "
            [claimMessageInfo]="fileAClaimPage?.question2Message[0]"
          ></pgh-claims-message>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
